import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AnnotationReport } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../contract/select/SelectMonths";
import { BasicButton } from "../../../theme/Component/BasicButton";


export const AnnotationReport = () => {

    const annotationReport = useDataBean(_AnnotationReport);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)

    const [filter, setFilter] = useState<any>({ State: 1, Year: _single.getCurrenYear() })


    useEffect(() => {
        getLista()

    }, [])




    const getLista = () => {

        annotationReport.instance.getAnnotationReportCatalogPorPropiedadesRender(_single.cleanMap(filter), null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        annotationReport.setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            AnnotationDate: _single.getCurrenDate()

        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        annotationReport.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAdd({ ...modalAdd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        annotationReport.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAnnotationReport', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },

        { title: 'Fecha de registro', property: 'Since', visible: true },
        { title: 'Tipo de anotacion', property: 'AnnotationTypeName', visible: true },
        { title: 'Descripcion Anotacion', property: 'Description', visible: true },
        { title: 'Accion Tomada', property: 'ActionTaken', visible: true },
        { title: 'Area que registra', property: 'FunctionalName', visible: true },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Adjuntos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalAdd({ ...modalAdd, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Anotaciones">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-4">
                            <YearSelector value={filter.Year} onChange={(e: any) => { setFilter({ ...filter, "Year": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectMonths idSelector={filter.Month} onChange={(e: any) => { setFilter({ ...filter, "Month": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectTHConstantsValue label="Tipo de Anotación" code={202} value={filter.AnnotationType} onChange={(e: any) => { setFilter({ ...filter, "AnnotationType": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <AccountEditor label="Funcionario" idAccount={filter.IDAccount} onChange={(e: any) => { setFilter({ ...filter, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12">
                            <BasicButton useMargin icon="" eventClick={getLista}>Buscar</BasicButton>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={annotationReport.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={annotationReport.bean.IDAccount} onChange={(e) => { annotationReport.setBean({ ...annotationReport.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo de anotacion</label>
                                    <SelectTHConstantsValue code={202} value={annotationReport.bean.AnnotationType} onChange={(e: any) => { annotationReport.setBean({ ...annotationReport.bean, "AnnotationType": e }) }}></SelectTHConstantsValue>
                                </div>

                                <div className="col-md-12">
                                    <label>Acción Tomada</label>
                                    <textarea name="ActionTaken" className="form-control" value={annotationReport.bean.ActionTaken} onChange={annotationReport.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <SelectFunctionalID label='Area Responsable' functionalIDLn={annotationReport.bean.IDlnFunctionalID} onChange={(e: any) => annotationReport.setBean({ ...annotationReport.bean, 'IDlnFunctionalID': e.IDLn })} />
                                </div>

                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={annotationReport.bean.Description} onChange={annotationReport.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>

                    <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={editaItem}>
                        <>
                            <div className="col-md-12">
                                <FileInput
                                    Media={annotationReport.bean.Media}
                                    MediaContext={annotationReport.bean.MediaContext}
                                    directory='anotaciones'
                                    label='Cargar un archivo'
                                    onCreate={({ MediaContext, Media }: any) => { annotationReport.setBean({ ...annotationReport.bean, "AttachFiles": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                ></FileInput>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}